export default __webpack_public_path__ + "static/media/carouselLeftNavDisabled.26c3d520.svg";